import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import './frontend.css';
import CustomPaginator from './CustomPaginator';

const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};


const MmSearch = ({ config }) => {
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('All');
  const [sort, setSort] = useState('HighToLow');
  const [rating, setRating] = useState(null);
  const [filterCategory, setFilterCategory] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [selectedCategoryItem, setSelectedCategoryItem] = useState(config.selectedCategory ? config.selectedCategory : null);
  const [selectedAmcItem, setSelectedAmcItem] = useState(null);
  const [selectedCategoryItemTmp, setSelectedCategoryItemTmp] = useState(config.selectedCategory ? config.selectedCategory : null);
  const [selectedAmcItemTmp, setSelectedAmcItemTmp] = useState(null);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [amc, setAmc] = useState([]);
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [funds, setFunds] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    debouncedFetchFunds();
    // setFirst(0);
    // setFunds([]);
    // fetchFunds();
  };

  const debouncedFetchFunds = useCallback(debounce(() => {
    applyFilter();
  }, 300), [search, filterCategory, selectedCategoryItem, selectedAmcItem, rating]);


  const handleFilterCategoryChange = (category) => {
    setFilterCategory(category);
  };


  const handleFilterCategoryItemChange = (e) => {
    setSelectedCategoryItemTmp(e.target.value);
  };

  const handleFilterAmcItemChange = (e) => {
    setSelectedAmcItemTmp(e.target.value);
  };

  const fetchFunds = useCallback(async () => {

    setLoading(true);
    const offset = first;
    const limit = rows;
    const sort_by = sortField ? sortField : 'sort_order';
    const sort_order = sortOrder === 1 ? 'asc' : 'desc';

    try {
      const productResponse = await axios.get(`${config.PY_API_URL}v2/category/${encodeURIComponent(selectedCategoryItem)}/products`, {
        params: {
          offset,
          limit,
          sort_by,
          sort_order,
          return_periods: '3,5',
          search,
          rating,
          product_owner: selectedAmcItem
        }
      });
      setHasMore(false);
      setFunds([...productResponse.data.data.products]);
      setTotalRecords(productResponse.data.data.total_count);
    } catch (error) {
      setHasMore(false);
      console.error('Error fetching funds:', error);
    } finally {
      setLoading(false);
    }
  }, [first, rows, sortField, sortOrder, search, rating, selectedAmcItem, selectedCategoryItem, config, loading, hasMore]);

  const applyFilter = (categoryData=[]) => {
    setFirst(0);
    setFunds([]);
    setHasMore(true);
    if (!categoryData.length) {
      categoryData = category;
    }
    if (selectedCategoryItemTmp) {
      setSelectedCategoryItem(selectedCategoryItemTmp)
      setSelectedCategoryItemTmp(null)
    }
    if (selectedAmcItemTmp) {
      setSelectedAmcItem(selectedAmcItemTmp)
      setSelectedAmcItemTmp(null)
    }
    const activeFilters = [];
    if (rating) activeFilters.push({ label: `Rating: ${rating}`, type: 'rating' });
    if (selectedCategoryItem) activeFilters.push({ label: `Category: ${categoryData.find(c => c.category_code == selectedCategoryItem)?.name || ''}`, type: 'category' });
    if (selectedAmcItem) activeFilters.push({ label: `AMC: ${amc.find(a => a.id == selectedAmcItem)?.name || ''}`, type: 'amc' });
    setSelectedFilters(activeFilters);
    console.log("activeFilters", activeFilters)
    setFilterCategory(null);
    fetchFunds();
  };

  const resetFilter = () => {
    setSelectedFilter(null);
    setSelectedCategoryItem(null);
    setSelectedAmcItem(null);
    setRating(null);
    fetchFunds();
    setFirst(0);
    setFilterCategory(null);
  };

  useEffect(() => {
    fetchData();
  }, [selectedCategoryItem, selectedAmcItem]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    fetchFunds();
  };

  const onSort = (event) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
    fetchFunds();
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const apiUrl = `${config.PY_API_URL}product/owners`;
      const response = await axios.get(apiUrl);
      setAmc(response.data.data.product_owners);

      const categoryApiUrl = `${config.PY_API_URL}category`;
      const categoryResponse = await axios.get(categoryApiUrl);
      const tree = buildCategoryTree(categoryResponse.data.data);
      setCategory(tree);
      applyFilter(tree);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const buildCategoryTree = (categories, parentCategoryId = 0, level = 0) => {
    const tree = [];
    categories.forEach(category => {
      if (category.parent_category_id === parentCategoryId) {
        const indentedName = `${'--'.repeat(level)}${category.name}`;
        const children = buildCategoryTree(categories, category.id, level + 1);
        tree.push({
          name: indentedName,
          category_code: category.category_code,
          id: category.id,
          children: children.length > 0 ? children : undefined
        });
        for (let ch of children) {
          tree.push(ch);
        }
      }
    });
    return tree;
  };

  const renderFilterOptions = () => {
    console.log("filterCategory", filterCategory);
    switch (filterCategory) {
      // case 'Ratings':
      //   return (
      //     <>
      //       {['NA', '1', '2', '3', '4', '5'].map(option => (
      //         <label key={option}>
      //           <input 
      //             type="radio" 
      //             value={option} 
      //             checked={rating === option} 
      //             onChange={handleSelectedRatingChange} 
      //           />
      //           {option}
      //         </label>
      //       ))}
      //     </>
      //   );
      case 'AMC':
        return (
          <>
            {amc.map(option => (
              <label key={`amc_${option.id}`}>
                <input 
                  type="radio" 
                  value={option.id} 
                  checked={selectedAmcItem == option.id || selectedAmcItemTmp == option.id} 
                  onChange={handleFilterAmcItemChange} 
                />
                {option.name}
              </label>
            ))}
          </>
        );
      case 'Category':
        return (
          <>
            {category.map(option => (
              <label key={`cc_${option.id}`}>
                <input 
                  type="radio" 
                  value={option.category_code} 
                  checked={selectedCategoryItem == option.category_code || selectedCategoryItemTmp == option.category_code} 
                  onChange={handleFilterCategoryItemChange} 
                />
                {option.name}
              </label>
            ))}
          </>
        );
      default:
        return null;
    }
  };

  const removeFilter = (type) => {
    console.log("removeFilter type", type);
    switch (type) {
      case 'rating':
        setRating(null);
        break;
      case 'category':
        setSelectedCategoryItem(null);
        setSelectedCategoryItemTmp(null);
        break;
      case 'amc':
        setSelectedAmcItem(null);
        setSelectedAmcItemTmp(null);
        break;
      default:
        break;
    }
    applyFilter();
  };

  return (
    <div className="funds-explorer">
      <h1>Search</h1>
      <div className="search-bar">
        <input 
          type="text" 
          placeholder="Search" 
          value={search} 
          onChange={handleSearchChange} 
        />
      </div>

      <div className="selected-filters">
          {selectedFilters && selectedFilters.map((filter, index) => (
            <span key={index} className="filter-tag">
              {filter.label}
              <button className="filter-remove" onClick={() => removeFilter(filter.type)}>x</button>
            </span>
          ))}
        </div>

      <div className="options-bar">
        <div className="filters">
        </div>
        <div className="sort-filter">
          {/* <div className="sort">
            <label>
              Sort:
              <select value={sort} onChange={handleSortChange}>
                <option value="HighToLow">High to Low</option>
                <option value="LowToHigh">Low to High</option>
              </select>
            </label>
          </div> */}
          <div className="filter-categories">
            {/* <button onClick={() => handleFilterCategoryChange('Ratings')} className={filterCategory === 'Ratings' ? 'active' : ''}>Ratings</button> */}
            <button onClick={() => handleFilterCategoryChange('AMC')} className={filterCategory === 'AMC' ? 'active' : ''}>AMC</button>
            <button onClick={() => handleFilterCategoryChange('Category')} className={filterCategory === 'Category' ? 'active' : ''}>Category</button>
          </div>
        </div>
      </div>
      { filterCategory && (
        <div className="filter-options">
          <div className="filter-items">
            {renderFilterOptions()}
          </div>
          <div className="filter-actions">
            <button onClick={applyFilter}>Apply</button>
            <button onClick={resetFilter}>Reset</button>
          </div>
        </div>)
      }
      <div className="funds-list">
        {loading && first === 0 ? (
          <div className="loader">Loading...</div>
        ) : (
          funds.map(fund => (
            <a className='product-card-link' href={`${config.siteUrl}/product-detail/${fund.product_code}`}>
              <div key={fund.id} className="fund-card row">
                <div className="fund-logo col-md-1">
                  <img src={fund.icon} alt={''} onError={(e) => e.target.src = 'https://placehold.co/100x100'} />
                </div>
                <div className="fund-info col-md-6">
                  <h2>{fund.name}</h2>
                  <p>{fund.type}</p>
                </div>
                {
                  fund.product_type_code == 1 &&
                  <div className="fund-returns col-md-3">
                    <div>
                      <h4>1 year</h4>
                      {
                        fund.returns_1_years && (
                          <p>{fund.returns_1_years}%</p>
                        )
                      }
                      {
                        fund.returns_1_years == null && (
                          <p>N/A</p>
                        )
                      }
                    </div>
                    <div>
                      <h4>3 years</h4>
                      {
                        fund.returns_3_years && (
                          <p>{fund.returns_3_years}%</p>
                        )
                      }
                      {
                        fund.returns_3_years == null && (
                          <p>N/A</p>
                        )
                      }
                    </div>
                    <div>
                      <h4>5 years</h4>
                      {(
                        fund.returns_5_years && (
                          <p>{fund.returns_5_years}%</p>
                        )
                      )}
                      {
                        fund.returns_5_years == null && (
                          <p>N/A</p>
                        )
                      }
                    </div>
                  </div>
                }
                {/* <div className="fund-rating col-md-1">
                  <h4>Rating</h4>
                  <span>{fund.rating}</span>
                </div> */}
                <div className="invest-button col-md-1">View</div>
              </div>
            </a>
          ))
        )}
        {loading && first > 0 && <div className="loader">Loading ...</div>}
        {!hasMore && !loading && !funds.length && <div className="end-message">Not data found.</div>}
        {totalRecords > rows && (
          <CustomPaginator
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </div>
  );
};

export default MmSearch;
